const scheduledServicesCalendarCalendar = {
  allDay: 'Dia todo',
  today: 'Hoje',
  month: 'Mês',
  week: 'Semana',
  day: 'Dia',
  agenda: 'Agenda',
  date: 'Data',
  time: 'Tempo',
  event: 'Evento',
  showMore: '+ Eventos ',
};

export default scheduledServicesCalendarCalendar;
